import { withOverlayControls } from '@eb/eds-structure';
import { withMainControls } from '@eb/eds-structure';
import withNotification from './_internal/withNotification';

import EventCard from './EventCard';

export default withMainControls(
    withOverlayControls(withNotification(EventCard)),
);
